// import { persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { userReducer } from './usersReducer'
import { settingsReducer } from './settingsReducer'
import { Action, ReducersMapObject } from '@reduxjs/toolkit'
import { ClientUser } from '../../../../../common/interfaces/User'
import persistCombineReducers from 'redux-persist/lib/persistCombineReducers'
import { UserSettings } from '../../type/userSettings'

const persistConfig = {
  key: 'root',
  storage
  // blacklist: [],
}

const reducers = {
  user: userReducer,
  settings: settingsReducer
}

export const rootReducers =
  persistCombineReducers(persistConfig, reducers as ReducersMapObject<{
    user: ClientUser,
    settings: UserSettings
  }, Action<any>>)

export type RootState = ReturnType<typeof rootReducers>
